<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputCheckboxList" });
import "tailwindcss/tailwind.css";
import { InputCheckbox } from "../index.js";
import Legend from "../../elements/legend/Legend.svelte";
import LabelError from "../../elements/label-error/LabelError.svelte";
import { handleInputError } from "../../common/validation.js";
export let keys;
export let name = "";
export let options = [];
export let label = void 0;
export let isDisabled = false;
export let isRequired = false;
export let minItems = 0;
export let maxItems = 100;
export let style = "default";
export let css = "";
export let whitelist = [];
let error = null;
const validate = (event) => {
    const TARGET = event.target;
    error = handleInputError(TARGET);
};
const filterWhitelist = (options2, whitelist2) => {
    if (whitelist2.length === 0) {
        return options2;
    }
    return options2.filter((option) => whitelist2.includes(option.value));
};
const setValidation = (keys2, maxItems2, minItems2) => {
    const COUNT = Array.isArray(keys2) ? keys2.length : 0;
    if (maxItems2 !== void 0 && COUNT > maxItems2) {
        return "max_items";
    }
    if (minItems2 !== void 0 && COUNT < minItems2) {
        return "min_items";
    }
    error = null;
    return "";
};
$: validation = setValidation(keys, maxItems, minItems);
</script>

<fieldset class = 's8-form-row'>

    {#if Array.isArray(options) && Array.isArray(keys)}

        <div class = 's8-header'>
            <Legend { label } { isDisabled }/>
        </div>

        <ul
            class = { `s8-checkbox-list ${ css }` }
            class:s8-invalid = { error !== null }
        >
            {#each filterWhitelist(options, whitelist) as option}
                <li>
                    <InputCheckbox
                        { name }
                        bind:keys
                        value = { option.value }
                        label = { option.label }
                        isDisabled={
                            isDisabled
                            || option.isDisabled === true
                            || (
                                maxItems === keys.length
                                && !keys.includes(option.value)
                            )
                        }
                        isRequired = { isRequired || option.isRequired }
                        isIndeterminate = { option.isIndeterminate }
                        { style }
                    />
                </li>
            {/each}
        </ul>

        <div class = 's8-footer'>
            <LabelError { error } />
        </div>

        <input
            type = 'hidden'
            data-custom-validation = { validation }
            on:invalid = { validate }
            name = { `hidden-${ name }` }
        />

    {/if}

</fieldset>

<style>

    fieldset.s8-form-row {
        display: flex;
        flex-direction: column;
        row-gap: 2px;
        margin-bottom: 10px;
    }

        fieldset.s8-form-row div.s8-header {
            display: flex;
            justify-content: space-between;
            min-height: 10px;
        }

        fieldset.s8-form-row div.s8-footer {
            min-height: 10px;
        }

        fieldset.s8-form-row ul.s8-checkbox-list {
            display: flex;
            -moz-column-gap: 10px;
                 column-gap: 10px;
            width: 100%;
            height: 36px;
        }

        fieldset.s8-form-row ul.s8-checkbox-list li {
                background: rgba(39,39,17,0.06);
                border-radius: 6px;
                align-items: center;
                width: 100%;
                height: 100%;
                padding-left: 10px;
                padding-right: 10px;
                display: flex;
            }

        fieldset.s8-form-row ul.s8-checkbox-list.s8-invalid li {
                color: rgba(239,35,59,1);
                background: rgba(239,35,59,0.12);
            }</style>